import $ from "jquery";

$(document).ready(function () {
    const selectors = {
        menu: '[data-cmp="menu"]',
    }
    

});